import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ListView from "../../../utils/Custom/listView";
import ListSearchSection from "../../../utils/Custom/ListSearchSection";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { AddButton, SearchToggleButton } from "../../../utils/Custom/Button";
import { AutoCompletes, DateInput } from "../../../utils/Custom/custominput";
import { getFormattedDates } from "../../../utils/utils";
import ExcelDownload from "../../../utils/commonComponent/ExcelDownload";
import { clienTypes } from "../../../utils/commonComponent/common";
import { getPermissions } from "../rbac/hasAccess";

const headers = ["id", "client", "poNumber", "subcategory"];
const notNeededColumn = [
  "status",
  "client_id",
  "servicesNameId",
  "id",
  "inspectorId",
  "jobRegisterId",
];
const SummaryReport = (props) => {
  const permissions = getPermissions(props.moduleId);
  const [selectedClientIDs, setSelectedClientIds] = useState([]);
  const [clientList, setClientList] = React.useState([]);
  const [summaryList, setSummaryList] = useState([]);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [searched, setSearched] = React.useState(false);
  const [from, setFromDate] = useState(null);
  const [to, setToDate] = useState(null);

  const getQuery = () => {
    let whereConditions = [];
    const colMap = {
      client: "cl.companyName",
      quotationNumber: "qt.quotationNumber",
    };
    const colName = colMap[searchBy];
    if (colName && searchKey.trim()) {
      whereConditions.push(`LOWER(${colName}) LIKE LOWER('%${searchKey.trim()}%')`);
    }

    if (to != null && from != null) {
      const { fromDate, toDate } = getFormattedDates(from, to);
      whereConditions.push(`DATE(jr.inspectionPerformedDate) BETWEEN '${fromDate}' and '${toDate}'`);
    }

    if (selectedClientIDs?.length > 0) {
      const clientIds = selectedClientIDs.map((id) => `'${id}'`).join(",");
      whereConditions.push(`jr.clientId IN (${clientIds})`);
    }

    const whereClause = whereConditions.length ? `WHERE ${whereConditions.join(" AND ")}` : "";

    const query = `SELECT cl.companyName AS client, jr.jobNumber, jr.poNumber, ii.subcategory  FROM jobRegisterInspection jri LEFT JOIN jobRegister jr ON jri.jobRegisterId = jr.id LEFT JOIN clients cl ON jr.clientId = cl.id LEFT JOIN inspectionItems ii ON jri.servicesNameId = ii.id ${whereClause}`;

    return query.trim();
  };

  const fetchClientList = async () => {
    try {
      const query = `select * from clients where status = 1`;
      const clientList = await fetchQuery(query);
      const modified = clientList?.map((item) => {
        return {
          ...item,
          companyName: item.companyName + (item.type ? ` (${clienTypes.find((ct) => ct.value == item.type)?.short || ""})` : ""),  
        };
      });
      setClientList(modified);
    } catch (error) {
      console.error("Error fetching clientList:", error);
    }
  };

  const fetchSummaryReport = async () => {
    try {
      const query = getQuery();
      const summaryReports = await fetchQuery(query);
      setSummaryList(summaryReports);
    } catch (error) {
      console.error("Error fetching summaryReports data:", error);
    }
  };

  const handleSearch = () => {
    if (selectedClientIDs.length < 1) {
      alert("Please select a client.");
      return;
    }
    fetchSummaryReport();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
    setFromDate(null);
    setToDate(null);
    setSearchBy("");
    setSearchKey("");
    setSelectedClientIds([]);
    setSummaryList([])
  };

  useEffect(() => {
    fetchClientList();
  }, []);

  // useEffect(() => {
  //   if (searched == false) {
  //     fetchSummaryReport();
  //   }
  // }, [searched]);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 my-3">
        <div className="w-full">
          <AutoCompletes
            label="Choose Client"
            options={clientList}
            value={clientList.filter((c) => selectedClientIDs?.includes(c.id))}
            onChange={(val) => {
              setSelectedClientIds(val);
              setSearched(false);
            }}
            isWidth
            valueKey="id"
            labelKey="companyName"
            multiple
          />
        </div>
        <div className="w-full">
          <DateInput
            id="from-date"
            label="From Date"
            value={from}
            onChange={(val) => {
              setFromDate(val);
              setSearched(false);
            }}
          />
        </div>
        <div className="w-full">
          <DateInput
            id="to-date"
            label="To Date"
            value={to}
            onChange={(val) => {
              setToDate(val);
              setSearched(false);
            }}
          />
        </div>
        <div>
          <SearchToggleButton
            searched={searched}
            onSearch={handleSearch}
            onClear={clearSearch}
          />
        </div>
        {summaryList?.length > 0 && (permissions.excelDownload || permissions.allAccess) && (
          <div>
            <ExcelDownload
              finalData={summaryList}
              notNeededColumn={notNeededColumn}
            />
          </div>
        )}
      </div>

      <ListView headers={headers} data={summaryList} />
    </>
  );
};

export default SummaryReport;
